import { makeActionCreator } from '../../config/store/utils'

export const OPEN_FORCED_EMT_DIALOG = 'OPEN_FORCED_EMT_DIALOG'
export const onOpenForcedEMTDialog = makeActionCreator(OPEN_FORCED_EMT_DIALOG, 'payload')

export const CLOSE_FORCED_EMT_DIALOG = 'CLOSE_FORCED_EMT_DIALOG'
export const onCloseForcedEMTDialog = makeActionCreator(CLOSE_FORCED_EMT_DIALOG, 'payload')
